// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__u5Mg1","banner":"styles_banner__uHYkI","bannerTitle":"styles_bannerTitle__GnY2I","bannerDesc":"styles_bannerDesc__Oj2NR","icon":"styles_icon__L6ZR+"};